import { styled } from '@mui/material/styles';

var PREFIX = "AskDownloadStep";
var classes = {
    link: "".concat(PREFIX, "-link"),
    subDescription: "".concat(PREFIX, "-subDescription"),
    description: "".concat(PREFIX, "-description"),
    error: "".concat(PREFIX, "-error"),
    textarea: "".concat(PREFIX, "-textarea"),
    textareaError: "".concat(PREFIX, "-textareaError"),
    formControl: "".concat(PREFIX, "-formControl")
};
var StyledAskDownloadStep = styled("div")(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {},
        _b["& .".concat(classes.link)] = {
            textTransform: "none",
            color: theme.palette.primary.main,
            textDecoration: "none",
            cursor: "pointer",
            fontWeight: "bold"
        },
        _b["& .".concat(classes.subDescription)] = {
            display: "block",
            color: theme.palette.text.secondary,
            marginBottom: theme.spacing(1),
            lineHeight: 1.5,
            hyphens: "auto",
            wordBreak: "normal"
        },
        _b["& .".concat(classes.description)] = {
            display: "block",
            color: theme.palette.text.secondary,
            padding: theme.spacing(2, 0, 0, 0),
            marginBottom: theme.spacing(1),
            lineHeight: 1.5,
            hyphens: "auto",
            wordBreak: "normal"
        },
        _b["& .".concat(classes.error)] = {
            color: theme.palette.error.main
        },
        _b["& .".concat(classes.textarea)] = {
            borderRadius: theme.shape.borderRadius
        },
        _b["& .".concat(classes.textareaError)] = {
            borderColor: theme.palette.error.main
        },
        _b["& .".concat(classes.formControl)] = {
            width: "100%",
            marginBottom: theme.spacing(2)
        },
        _b);
});

export { classes, StyledAskDownloadStep as default };
//# sourceMappingURL=index.styled.js.map
